import React, { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import './App.css';
import ErrorPage from './ErrorPage.js';
import PageHeader from './Components/PageHeader/PageHeader.jsx';
import PageFooter from './Components/PageFooter/PageFooter.jsx';
import { defaultCities } from './Constant/constant.js';
import { useLocation } from 'react-router-dom';

const App = () => {
  const citiesFromStorage = JSON.parse(localStorage.getItem('cities'));
  if (citiesFromStorage && '國資圖電子書平台' in citiesFromStorage) {
    delete citiesFromStorage['國資圖電子書平台'];
  }
  const [cities, setCities] = useState(
    citiesFromStorage ? citiesFromStorage : defaultCities
  );
  const [hyreadLoaded, setHyreadLoaded] = useState(false);
  const [udnLoaded, setUdnLoaded] = useState(false);
  const [publicLoaded, setPublicLoaded] = useState(false);
  const [cloudLoaded, setCloudLoaded] = useState(false);
  const [ireadLoaded, setIreadLoaded] = useState(false);
  const [noCityWarning, setNoCityWarning] = useState(false);

  return (
    <div className="App">
      <Suspense fallback={<div>Loading...</div>}>
        <PageHeader
          cities={cities}
          setCities={setCities}
          allLoaded={
            hyreadLoaded &&
            udnLoaded &&
            publicLoaded &&
            cloudLoaded &&
            ireadLoaded
          }
          noCityWarning={noCityWarning}
          setNoCityWarning={setNoCityWarning}
        />
        <Outlet
          context={{
            cities,
            setCities,
            setHyreadLoaded,
            setUdnLoaded,
            setPublicLoaded,
            setCloudLoaded,
            setIreadLoaded,
            noCityWarning,
          }}
        />
        <PageFooter />
        {/* <HeadwayWidget /> */}
      </Suspense>
    </div>
    // <ErrorPage />
  );
};

export default App;
